<template>
  <v-select
    v-model="selfValue"
    v-bind="allProps"
    :options="options"
    @search="searchMethod"
    @input="changeMethod"
    @option:created="createdMethod"
    @open="openMethod"
  >
    <span slot="no-options">{{ $t("general.noMatchingRecordsFound") }}</span>
  </v-select>
</template>

<script>
import vSelect from 'vue-select'

const DEFAULT_PROPS = { label: 'title', optionText: 'title', dir: 'rtl' }

export default {
  name: 'VSelectCustom',
  components: {
    vSelect,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: null, // any value type,
    customProps: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selfValue: null,
    }
  },
  computed: {
    allProps() {
      return { ...DEFAULT_PROPS, ...this.customProps }
    },
  },
  watch: {
    selfValue(val) {
      this.$emit('input', val)
    },
    value: {
      handler(val) {
        this.selfValue = val
      },
      immediate: true,
    },
  },
  methods: {
    searchMethod(search) {
      this.$emit('search', search)
    },
    changeMethod(val) {
      this.$emit('change', val)
    },
    createdMethod(newOption) {
      this.$emit('option:created', newOption)
    },
    openMethod() {
      this.$emit('open')
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss"
</style>
